import axios from 'axios';
import { globalConfig } from 'src/config';

const axiosNoAuthInstance = axios.create({
    baseURL: globalConfig.baseUrl,
    timeout: 90000
});

axiosNoAuthInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        return Promise.reject((
            error.response && error.response.data
        ) || { title: 'Something went wrong' });
    }
);

export default axiosNoAuthInstance;
